<template>
  <v-container fluid mb-12 mt-5 style="width: 90%">
    <v-row>
      <v-col sm="3" md="6" offset-lg="0">
        <h1>Users</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <hr />
    <div class="v-row">
      <v-col cols="6">
        <v-btn-toggle
          v-model="tableDisplay"
          tile
          color="deep-purple accent-3"
          group
          class="text-center"
          rounded
          mandatory
        >
          <v-btn value="users">
            Users
          </v-btn>
          <v-btn value="positions">
            User Roles
          </v-btn>
          <v-btn value="permissions">
            Permission
          </v-btn>
          <v-btn value="permission_groups">
            User Roles Permission
          </v-btn>
          <!-- <v-btn value="senders">
            Senders
          </v-btn> -->
        </v-btn-toggle>
      </v-col>
    </div>
    <UserTable :tableDisplay="tableDisplay" :search="search" :isFetching="isFetching"/>
    <PositionTable :tableDisplay="tableDisplay" :search="search" />
    <PermissionTable :tableDisplay="tableDisplay" :search="search" />
    <PermissionGroupTable :tableDisplay="tableDisplay" :search="search" />
    <!-- <SendersTable :tableDisplay="tableDisplay" :search="search" /> -->
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import UserTable from "../../components/users/Users";
  import PositionTable from "../../components/users/UserPositions";
  import PermissionTable from "../../components/users/UserPermissions";
  import PermissionGroupTable from "../../components/users/PermissionGroups";
  // import SendersTable from "../../components/documents/Senders";

  export default {
    name: "Users",
    components: {
      UserTable,
      PositionTable,
      PermissionTable,
      PermissionGroupTable,
      // SendersTable,
    },
    data() {
      return {
        isFetching: false,
        showSuccess: false,
        singleSelect: false,
        selected: [],
        search: "",
        dialog: false,
        tableDisplay: "users",
        headers: [
          {
            text: "Name",
            align: "start",
            sortable: true,
            value: "name",
          },
          { text: "Email", value: "email" },
          { text: "Date Created", value: "date" },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ],
        editedItem: {
          name: "",
          calories: 0,
          fat: 0,
          carbs: 0,
          protein: 0,
        },
        items: [
          { title: "Click Me" },
          { title: "Click Me" },
          { title: "Click Me" },
          { title: "Click Me 2" },
        ],
        expanded: [],
        singleExpand: false,
        permission_dialog: false,
        selectedPermissionList: {},
        position_dialog: false,
        selectedPositionList: {},
        office_dialog: false,
        selectedOfficeList: {},
        userDialog: false,
      };
    },
    methods: {
      ...mapActions(["fetchUsers"]),
      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        const index = this.desserts.indexOf(item);
        confirm("Are you sure you want to delete this item?") &&
          this.desserts.splice(index, 1);
      },
      closeUserDialog(val) {
        if (!val) {
          this.userDialog = false;
          this.selectedUser = null;
        } else {
          this.userDialog = false;
          this.selected = null;
          this.showSuccess = true;
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
        } else {
          this.desserts.push(this.editedItem);
        }
        this.close();
      },
      openPermissionModal(item) {
        this.selectedPermissionList = {
          id: item.id,
          permissions: item.permissions,
        };
        this.permission_dialog = true;
      },
      closePermissionDialog() {
        this.permission_dialog = false;
        this.selectedPermissionList = {};
      },
      openPositionModal(item) {
        this.selectedPositionList = { id: item.id, positions: item.positions };
        this.position_dialog = true;
      },
      closePositionDialog() {
        this.position_dialog = false;
        this.selectedPositionList = {};
      },
      openOfficeModal(item) {
        this.selectedOfficeList = { id: item.id, offices: item.offices };
        this.office_dialog = true;
      },
      closeOfficeDialog() {
        this.office_dialog = false;
        this.selectedOfficeList = {};
      },
      openSenderModal(item) {
        this.selectedOfficeList = { id: item.id, offices: item.senders };
        this.office_dialog = true;
      },
      closeSenderDialog() {
        this.office_dialog = false;
        this.selectedOfficeList = {};
      },
      editUser(item) {
        this.userDialog = true;
        this.selectedUser = item;
      },
    },
    computed: {
      ...mapGetters(["allUsers"]),
      permissionDialog: function() {
        return this.permission_dialog;
      },
    },
    created() {
      if(this.allUsers.length == 0)
      this.isFetching = true;
      this.fetchUsers({ itemsPerPage: 0 }).then(() => {
        this.isFetching = false;
      });
    },
  };
</script>

<style scoped>
  .action-item {
    cursor: pointer;
  }
</style>
